export default __webpack_public_path__ + "static/media/uploader-relion-1.0f837a4f.png";